
export default class CopyOperation {
  constructor (parts) {
    this.copiedParts = parts;
  }

  opType () {
    return 'copy';
  }

  getRootParts (root) {
    return this.copiedParts
  }

}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/operations/copy_operation.js